:host {
  display: block;
}

.total-amount{
  display: inline-block;
}
